import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'cv-permission-assign-box',
    templateUrl: './permission-assign-box.component.html',
    styleUrls: ['./permission-assign-box.component.scss']
})
export class PermissionAssignBoxComponent implements OnInit {
    @Input() lst: any[];
    @Output() lstChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() showall: boolean;
    @Output() showallChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() empgrouptypes: any;
    @Output() empgrouptypesChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() recgrouptypes: any;
    @Output() recgrouptypesChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() datatransfer: any;
    @Output() datatransferChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() onremove: EventEmitter<any> = new EventEmitter<any>();

    constructor() { }

    ngOnInit(): void {
    }

    removeGroup(group) {
        if (group.default)
            return;

        for (let i = 0; i < this.lst.length; ++i)
            if (this.lst[i] == group)
                this.lst.splice(i, 1);

        this.onremove.emit({ dto: group });
    }

    trackByFunction(index: number, el: any) {
        return index;
    }

}
